import React from 'react';
import cn from 'classnames';

import ActionMenuItem from './ActionMenuItem/ActionMenuItem';

const ActionMenu = ({menuItems, title, className}) => {
  const renderItem = (children, key) => {
    return (
      <li className="action-menu__list-item" key={key}>
        {children}
      </li>
    );
  };

  return (
    <div className={cn('action-menu', className)}>
      {title && <p className="action-menu__title">{title}</p>}
      <ul className="action-menu__list">
        {menuItems.map((item, index) => {
          if (Array.isArray(item)) {
            return renderItem(item.map(subItem => <ActionMenuItem key={subItem.title} {...subItem}/>), index);
          }

          return renderItem(<ActionMenuItem {...item}/>, index);
        })}
      </ul>
    </div>
  );
};

export default ActionMenu;
